// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3973) return "static/chunks/3973.c27002b9f4267a55.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"809":"e180a7554e10e8ef","5102":"240d962c3d663287"}[chunkId] + ".js";
};